import { forwardRef, type MouseEventHandler, type ReactNode } from "react";
import { cn } from "@utils/cn.ts";

interface ButtonInitialProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  teamDisabled?: boolean;
  children: ReactNode;
  className?: string;
}

const ButtonInitial = forwardRef<HTMLButtonElement, ButtonInitialProps>(
  ({ onClick, disabled, children, teamDisabled, className }, ref) => {
    return (
      <>
        <button
          ref={ref}
          type="button"
          disabled={disabled}
          onClick={onClick}
          className={cn(
            "px-2 py-2  min-w-[60px] rounded-[48px] transition-all border group border-zinc-300 flex items-center justify-center font-pretendard text-sm",
            className,
            teamDisabled && "cursor-not-allowed disabled:opacity-30",
            !teamDisabled && !disabled && "hover:border-zinc-500 ",
            disabled && "cursor-not-allowed! disabled:opacity-50 "
          )}
        >
          <span className="font-pretendard text-sm font-[500] inline-flex items-center justify-center gap-1.5">
            {children}
          </span>
        </button>
      </>
    );
  }
);

ButtonInitial.displayName = "ButtonInitial";

export default ButtonInitial;
